export { default as encryptPwd } from './encrypt';
export { default as pinyin } from './pinyin';

// 检查手机号
export const validPhone = (phone) => {
  const reg = /^1[3-9]\d{9}$/;
  return reg.test(phone);
}

// 检查邮箱
export const validEmail =(str) => {
  const reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
  return reg.test(str);
}

// 防抖
export const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, arguments);
    }, delay)
  }
}

// 节流
export const throttle = (fn, delay) => {
  let timer = null;
  return function () {
    if (timer) return;
    timer = setTimeout(() => {
      fn.apply(this, arguments);
      timer = null;
    }, delay)
  }
}

// 格式化日期
export const formatDate = (time) => {
  return time.toLocaleDateString().replace(/\//g, "-");
}

// 乘法
export const multiplication = (a, b) => {
  let m = 0;
  const s1 = a.toString();
  const s2 = b.toString();

  m += s1.split(".")[1]?.length || 0;
  m += s2.split(".")[1]?.length || 0;

  const n1 = Number(s1.replace(".", ""));
  const n2 = Number(s2.replace(".", ""));

  return (n1 * n2 / (10 ** m));
}